export const WHATSAPP_NUMBER = '5491169373036' // +54 9 11 6937 3036

export const DEFAULT_MESSAGE =
  'Hola, quisiera consultar disponibilidad y tarifas para alojarme en Cabañas El Mirador.'
export const LOCATION_MESSAGE =
  'Hola! Me podrían enviar la ubicación exacta de las cabañas?'

export const getCabinMessage = (cabinName: string) =>
  `Hola, quisiera consultar disponibilidad y tarifas para la cabaña ${cabinName} en Cabañas El Mirador.`

export function getWhatsAppLink(message: string = DEFAULT_MESSAGE) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}

export function openWhatsApp(message: string = DEFAULT_MESSAGE) {
  window.open(getWhatsAppLink(message), '_blank')
}
